import { Component } from '@angular/core';
import { RouterLink } from "@angular/router";
import { NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle } from "@ng-bootstrap/ng-bootstrap";
import {
  AgActionIconButtonComponent
} from '@shared/components/grid/ag-cells/common/ag-action-icon-button/ag-action-icon-button.component';
import { HasRoleDirective } from '@shared/directives/has-role.directive';
import { getCompanyProfilePath } from "@shared/utils/route-path-utils";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { Company } from "@models/companies/company";
import { AlertStatus } from '@models/alerts/alerts-enums';

type ActionEvent = (data: unknown) => void;

type CellRendererParams = ICellRendererParams<Company> & {
  editPartnerAndAccountManager: ActionEvent,
  downloadCompanyProfilePdf: ActionEvent,
  exportCompanyProfile: ActionEvent,
  managePins: ActionEvent,
  openAlerts: ActionEvent,
  onOpenNotes: ActionEvent,
};

@Component({
  selector: 'app-ag-company-actions',
  standalone: true,
  imports: [
    NgbDropdown,
    NgbDropdownItem,
    NgbDropdownMenu,
    NgbDropdownToggle,
    AgActionIconButtonComponent,
    HasRoleDirective,
    RouterLink
  ],
  templateUrl: './ag-company-actions.component.html',
  styleUrl: './ag-company-actions.component.scss'
})
export class AgCompanyActionsComponent implements ICellRendererAngularComp {
  params!: CellRendererParams;
  numberOfAlerts = 0;
  numberOfNewAlerts = 0;
  companyProfilePageLink: string[] | null = null;
  alertIconClass = "";

  agInit(params: CellRendererParams): void {
    this.updateCell(params);
  }

  refresh(params: CellRendererParams): boolean {
    return this.updateCell(params);
  }

  updateCell(params: CellRendererParams): boolean {
    this.params = params;
    this.numberOfNewAlerts = this.params.data?.alerts?.filter(alert => alert.status === AlertStatus.New && alert.isRead == false).length ?? 0;
    this.numberOfAlerts = this.params.data?.alerts?.length ?? 0;
    this.alertIconClass = "ic-alert-triangle-16 " + (this.numberOfNewAlerts ? "bg-red" : "")
    this.companyProfilePageLink = this.params.data?.entityId ? getCompanyProfilePath(this.params.data?.entityId) : null;
    return true;
  }

  editPartnerAndAccountManager(): void {
    this.params.editPartnerAndAccountManager(this.params.data);
  }

  downloadCompanyProfilePdf(): void {
    this.params.downloadCompanyProfilePdf(this.params.data);
  }

  onManagePins(): void {
    // this.params.managePins(this.params.data);
  }

  onOpenAlerts(): void {
    this.params.openAlerts(this.params.data);
  }

  onOpenNotes(): void {
    this.params.onOpenNotes(this.params.data);
  }
}
